import { productFamilyIdFormat } from "@redotech/redo-model/ids";
import { ListingTypeSchema } from "@redotech/redo-model/inventory/base-listing";
import * as z from "zod/v4";

export const enableListing = {
  name: "enableListing" as const,
  input: z.object({
    listingType: ListingTypeSchema,
    productFamilyId: productFamilyIdFormat.schema,
  }),
  output: z.void(),
};
